var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 31.4321C24.2052 31.4321 30.8569 24.7804 30.8569 16.5749C30.8569 8.36954 24.2052 1.71777 15.9997 1.71777C7.79435 1.71777 1.14258 8.36954 1.14258 16.5749C1.14258 24.7804 7.79435 31.4321 15.9997 31.4321Z",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5703 23.4321H19.4275",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 23.4321V15.4321H13.7148",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 10.2893C15.6836 10.2893 15.4277 10.0335 15.4277 9.71791C15.4277 9.40233 15.6836 9.14648 15.9992 9.14648",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10.2893C16.3156 10.2893 16.5714 10.0335 16.5714 9.71791C16.5714 9.40233 16.3156 9.14648 16 9.14648",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_2729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.574707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.e69f65f1e46d1526b8adf02bc37de1e4.svg";
export { ForwardRef as ReactComponent };